import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-editv3",
  "use": "icon-editv3-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20\" id=\"icon-editv3\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M3.333 5c0-.92.746-1.667 1.667-1.667h3.333a.833.833 0 0 1 0 1.667H5v10h10v-3.75a.833.833 0 1 1 1.667 0V15c0 .92-.747 1.667-1.667 1.667H5c-.92 0-1.667-.747-1.667-1.667V5Zm12.673-1.006a.833.833 0 0 1 0 1.179l-6.84 6.91h-1.25v-1.25l6.911-6.839a.833.833 0 0 1 1.179 0Z\" fill=\"currentColor\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol